export default __webpack_public_path__ + "images/plot-type-full-stacked-bar.769fbf2f5e8bdf1b0b8d3803856b35fb.svg";